import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { filter, Observable, take, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

/**
 * Resolver pour les routes non authentifiées
 * Charge uniquement les traductions pour les pages publiques (login, signup, etc.)
 */
@Injectable({
    providedIn: 'root'
})
export class NoAuthTranslationResolver implements Resolve<any>
{
    constructor(
        private translateService: TranslateService
    ) {}

    waitTranslation(): Observable<any> {
        // Vérifier immédiatement si les traductions sont déjà chargées
        const currentLang = this.translateService.currentLang || this.translateService.defaultLang;
        const translations = this.translateService.translations[currentLang];
        
        if (translations && Object.keys(translations).length > 0) {
            // Les traductions sont déjà disponibles, retourner immédiatement
            return of(translations);
        }
        
        // Sinon, attendre le prochain changement de traduction
        return this.translateService.onTranslationChange.pipe(
            filter(() => {
                const lang = this.translateService.currentLang;
                const trans = this.translateService.translations[lang];
                return trans && Object.keys(trans).length > 0;
            }),
            take(1)
        );
    }

    /**
     * Résout les traductions pour les routes non authentifiées
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return this.waitTranslation();
    }
}
